/*
  Tabbed
 */

var Tabbed = (function ($) {
  var m = (function () {
    var name = 'Tabbed';
    var version = '0.0.1';

    /*
      Local variable declarations
    */

    /*
      Handlers
    */
    // Return all elements that match selector
    // except elements that are childen of parents
    // that match mask.
    $.fn.findUntil = function (selector, mask, result) {
      result = typeof result !== 'undefined' ? result : new jQuery();

      this.children().each(function () {
        var thisObject = $(this);
        if (thisObject.is(selector)) {
          result.push(this);
        }
        if (!thisObject.is(mask)) {
          thisObject.findUntil(selector, mask, result);
        }
      });

      return result;
    };

    var handlers = {
      getDropdowns: function ($element) {
        return $element.findUntil('.js-tabbed__dropdown', '.js-tabbed');
      },
      getPanels: function ($element) {
        return $element.findUntil('.js-tabbed__panel', '.js-tabbed');
      },
      getTabs: function ($element) {
        return $element.findUntil('.js-tabbed__tab', '.js-tabbed');
      },
      hideToggles: function ($element) {
        handlers.getDropdowns($element).hide();
        handlers.getTabs($element).hide();
      },
      showToggles: function ($element) {
        handlers.getDropdowns($element).show();
        handlers.getTabs($element).show();
      },
      showAllPanels: function ($element) {
        handlers.getPanels($element).show();
      },
      disable: function ($element) {
        $element.data('tabbed-disabled', true);
        handlers.hideToggles($element);
        handlers.showAllPanels($element);
      },
      enable: function ($element) {
        $element.data('tabbed-disabled', false);
        handlers.showToggles($element);
        handlers.init($element);
      },
      init: function ($element) {
        var index = 0;

        if ($element.data('tabbed-shown')) {
          index = $element.data('tabbed-shown');
        }

        handlers.showTab($element, index, true);
      },
      showTab: function ($element, index, changeDropdown) {
        if ($element.data('tabbed-disabled')) { return; }

        // Update tab classes
        var $tabs = handlers.getTabs($element);
        $tabs.each(function (i) {
          if (i === index) {
            $(this).parent().addClass('is-selected');
          }
          else {
            $(this).parent().removeClass('is-selected');
          }
        });

        // Show / hide panels
        var $panels = handlers.getPanels($element);
        $panels.hide();
        $panels.eq(index).show();

        // Update dropdowns
        if (changeDropdown) {
          var $dropdowns = $element.find('select.js-tabbed__dropdown');
          if ($dropdowns.length) {
            $dropdowns.each(function () {
              $(this).find('option').eq(index).prop('selected', true);
              $(this).trigger('change');
            });
          }
        }
      },
      tabSelect: function ($trigger) {
        var $element = $trigger.closest('.js-tabbed');
        var index;
        var changeDropdown = true;

        if ($trigger.is('select')) {
          index = $trigger.find('option:selected').index();
          changeDropdown = false;
        }
        else {
          index = handlers.getTabs($element).index($trigger);
        }

        handlers.showTab($element, index, changeDropdown);

        $trigger.trigger('blur');
      },
    };

    /*
      List handlers that should be
      accessible in the global namespace
    */
    var publicHandlers = [
      'disable',
      'enable',
      'init',
      'showTab',
      'tabSelect',
    ];

    /*
      Events
    */
    var events = {
      breakpoints: function () {
        $('.js-tabbed').each(function () {
          var $element = $(this);

          if ($element.data('tabbed-breakpoint')) {
            enquire.register('screen and ' + $element.data('tabbed-breakpoint'), {
              // Disable
              match: function () {
                handlers.disable($element);
              },
              // Enable
              unmatch: function () {
                handlers.enable($element);
              }
            });
          }
        });
      },
      onTabClick: function () {
        $('.js-tabbed__tab').on('click', function (event) {
          event.preventDefault();
          handlers.tabSelect($(this));
        });
      },
      onTabSelectChange: function () {
        $('.js-tabbed__dropdown').on('change', function () {
          handlers.tabSelect($(this));
        });
      },
      pageLoad: function () {
        $('.js-tabbed').each(function () {
          handlers.init($(this));
        });
      },
    };

    /*
      List events in the order they
      should be bound. Any unlisted
      events will be registered last.
    */
    var eventOrder = [
      'pageLoad',
    ];

    /************************************************************************************
      DON'T EDIT BELOW THIS LINE
    ************************************************************************************/

    var bindEvents = function () {
      var eventNames = Object.keys(events);
      for (var i = 0; i < eventNames.length; i++) {
        var eventName = eventNames[i];
        if (eventOrder.indexOf(eventName) < 0) {
          eventOrder.push(eventName);
        }
      }

      for (var i = 0; i < eventOrder.length; i++) {
        var eventName = eventOrder[i];
        var event = events[eventName];

        if (event !== undefined) {
          if (typeof (event) === 'function') {
            try {
              event();
            }
            catch (e) {
              console.error('Event binding failed: ' + eventName);
              console.error(e);
            }
          }
          else {
            console.error('Event is not a function: ' + eventName);
          }
        }
        else {
          console.error('Event is undefined: ' + eventName);
        }
      }
    };

    var registerPublicHandlers = function () {
      for (var i = 0; i < publicHandlers.length; i++) {
        var handlerName = publicHandlers[i];
        var handler = handlers[handlerName];
        if (handler !== undefined) {
          if (typeof (handler) === 'function') {
            interface[handlerName] = handler;
          }
          else {
            console.error('Handler is not a function: ' + handlerName);
          }
        }
        else {
          console.error('Handler is undefined: ' + handlerName);
        }
      }
    };

    var interface = {
      _init_: function () {
        registerPublicHandlers();
        bindEvents();
        delete interface._init_;
      },
      toString: function () {
        return name + ' (version ' + version + ')';
      },
    };

    return interface;
  }());

  // Error-safe initialization
  $(function () {
    try {
      m._init_();
    }
    catch (e) {
      console.error('Module failed to initialize: ' + m);
      console.error(e);
    }
  });

  return m;
}(jQuery));
